'use strict';

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    UrbanEnvironmentWidgetController.$inject = ['$q', '$translate', 'iotService', 'measurementsService'];
    angular.module('app.iot').component('urbanEnvironmentWidget', {
        template: '<div class="panel dashboard-panel {{$ctrl.cssClass}}" translate-namespace="iot"><div class="panel-heading"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h2><span translate>.Urban monitoring</span><span class="header-date">{{$ctrl.currentDate}}</span></h2></div></div></div><div class="panel-heading" style="padding-top: 0; padding-bottom: 0;"><div class="row"><div class="col-xs-7 col-sm-7 col-md-7 col-lg-7"><h3 translate>.Weather conditions</h3></div><div class="col-xs-5 col-sm-5 col-md-5 col-lg-5"><div class="panel-heading-controls"><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fa fa-map-marker" aria-hidden="true"></i></span><select class="form-control input-sm" ng-model="$ctrl.weatherFoi" ng-options="o[$ctrl.translations[\'foi.name\']] for o in $ctrl.weatherFoiOptions" ng-change="$ctrl.onWeatherFoiChange()"></select></div></div></div></div></div><div class="panel-body"><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><span style="font-size:4em;">{{$ctrl.latestWeather[\'ambient-temperature\'] | number : 0}}{{$ctrl.panels[\'ambient-temperature\'].unit}}</span></div><div class="col-xs-8 col-sm-8 col-md-8 col-lg-8"><ul class="list-unstyled"><li>{{$ctrl.panels[\'ambient-humidity\'][$ctrl.translations[\'modality.name\']]}}: <span ng-if="$ctrl.latestWeather[\'ambient-humidity\']">{{$ctrl.latestWeather[\'ambient-humidity\'] | number : 1}} {{$ctrl.panels[\'ambient-humidity\'].unit}}</span><span ng-if="!$ctrl.latestWeather[\'ambient-humidity\']">-</span></li><li>{{$ctrl.panels[\'wind-speed\'][$ctrl.translations[\'modality.name\']]}}: <span ng-if="$ctrl.latestWeather[\'wind-speed\']">{{$ctrl.latestWeather[\'wind-speed\'] | number : 1}} {{$ctrl.panels[\'wind-speed\'].unit}} {{$ctrl.latestWeather[\'wind-direction\'] | toCompass:$ctrl.compass:\'\'}} <i ng-if="$ctrl.latestWeather[\'wind-direction\']" class="fa fa-long-arrow-up" style="transform:rotate({{$ctrl.latestWeather[\'wind-direction\'] | toDirection}}deg)" aria-hidden="true"></i></span> <span ng-if="!$ctrl.latestWeather[\'wind-speed\']">-</span></li></ul><div class="btn-group btn-group-sm" role="group" aria-label ng-init="modality_name_attr = (\'modality.name\' | translate)"><button type="button" class="btn btn-red" ng-repeat="panel in $ctrl.panels" ng-model="$ctrl.activePanel" uib-btn-radio="panel" ng-click="$ctrl.onChartChange()">{{panel[modality_name_attr]}}</button></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><nvd3 class="nvd3-chart" config="$ctrl.uiConfig.lineChart.config" options="$ctrl.uiConfig.lineChart.options" data="$ctrl.weatherCharts[$ctrl.activePanel.slug]"></nvd3></div></div></div><div class="panel-footer"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="text-right"><a ui-sref="historical-data({category: 1, categories: { 1: {fois: [$ctrl.weatherFoi.id], modality: $ctrl.activePanel.id, from: {value: -24, unit: \'hours\'}, granularity: \'hours\'}}})"><span translate>.see more</span></a></div></div></div></div><div class="panel-heading"><div class="row"><div class="col-xs-7 col-sm-7 col-md-7 col-lg-7"><h3 translate>.Gasses measurements</h3></div><div class="col-xs-5 col-sm-5 col-md-5 col-lg-5"><div class="panel-heading-controls"><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fa fa-map-marker" aria-hidden="true"></i></span><select class="form-control input-sm" ng-model="$ctrl.gasFoi" ng-options="o[$ctrl.translations[\'foi.name\']] for o in $ctrl.gasFoiOptions" ng-change="$ctrl.onGasFoiChange()"></select></div></div></div></div></div><div class="panel-body"><table class="table table-condensed" ng-init="modality_name_attr = (\'modality.name\' | translate)"><tr ng-repeat="gas in $ctrl.gasses"><td><a ui-sref="historical-data({category: 1, categories: { 1: {fois: [$ctrl.gasFoi.id], modality: gas.id, from: {value: -24, unit: \'hours\'}, granularity: \'hours\'}}})" translate-attr="{ title: \'iot.see more\'}">{{gas[modality_name_attr]}}</a></td><td class="text-right">{{$ctrl.latestGasses[gas.slug] | number: 0}} <small>{{gas.unit}}</small></td><td style="padding:2px 5px 2px 15px; width: 1%;"><nvd3 class="nvd3-chart" options="$ctrl.uiConfig.sparkLineChart.options" config="$ctrl.uiConfig.sparkLineChart.config" data="$ctrl.gassesCharts[gas.slug]"></nvd3></td></tr></table></div></div>',
        controller: UrbanEnvironmentWidgetController,
        controllerAs: '$ctrl',
        bindings: {
            cssClass: '@',
            lineColor: '@'
        }
    });

    function UrbanEnvironmentWidgetController($q, $translate, iotService, measurementsService) {
        'ngInject';

        var $ctrl = this;

        ////////////////

        /**
         * 
         */
        $ctrl.$onInit = function () {

            $ctrl.uiConfig = getUiConfig();
            $ctrl.currentDate = d3.time.format('%d/%m/%Y')(new Date());
            $q.all({
                modalityOptions: iotService.getModalities(),
                foiOptions: iotService.getInfrastructure(),
                granularityOptions: measurementsService.getGranularities(),
                weatherFoiOptions: iotService.getFoisOnline('weather'),
                gasFoiOptions: iotService.getFoisOnline('gasses'),
                translations: getTranslations()
            }).then(function (r) {

                $ctrl.translations = r.translations;
                $ctrl.granularity = _.find(r.granularityOptions, { id: 'hours' });
                $ctrl.modalityOptions = r.modalityOptions;

                $ctrl.panels = {
                    'ambient-temperature': _.find(r.modalityOptions, { slug: 'ambient-temperature' }),
                    'ambient-humidity': _.find(r.modalityOptions, { slug: 'ambient-humidity' }),
                    'wind-speed': _.find(r.modalityOptions, { slug: 'wind-speed' })
                };

                $ctrl.activePanel = $ctrl.panels['ambient-temperature'];
                $ctrl.weatherCharts = {};
                $ctrl.gassesCharts = {};

                $ctrl.gasses = {
                    'co2': _.find(r.modalityOptions, { slug: 'co2' }),
                    'no': _.find(r.modalityOptions, { slug: 'no' }),
                    'no2': _.find(r.modalityOptions, { slug: 'no2' }),
                    'so2': _.find(r.modalityOptions, { slug: 'so2' }),
                    'o3': _.find(r.modalityOptions, { slug: 'o3' })
                };

                setTranslations($ctrl.translations);

                $ctrl.weatherFoiOptions = r.weatherFoiOptions;
                $ctrl.weatherFois = Array.from($ctrl.weatherFoiOptions);
                $ctrl.weatherFoiOptions.unshift({
                    id: 'avg',
                    name: "Heraklion (Average)",
                    name_el: "Ηράκλειο (Μέσος Όρος)"
                });
                $ctrl.weatherFoi = $ctrl.weatherFoiOptions[0];

                $ctrl.gasFoiOptions = r.gasFoiOptions;
                $ctrl.gasFoi = $ctrl.gasFoiOptions[0];

                $ctrl.onWeatherFoiChange();
                $ctrl.onGasFoiChange();
            });
        };

        $ctrl.onChartChange = function () {
            var chart = $ctrl.weatherCharts[$ctrl.activePanel.slug];

            var min = _.get(chart, '0.min.avg', undefined),
                max = _.get(chart, '0.max.avg', undefined);

            $ctrl.uiConfig.lineChart.options.chart.forceY = [];

            if (min) {
                $ctrl.uiConfig.lineChart.options.chart.forceY.push(min - min * 0.1);
            }
            if (max) {
                $ctrl.uiConfig.lineChart.options.chart.forceY.push(max + max * 0.1);
            }
        };

        $ctrl.onWeatherAvg = function () {
            measurementsService.getLatestFoiMeasurements($ctrl.weatherFois).then(function (r) {
                var total = [];
                total['ambient-temperature'] = 0;
                total['ambient-humidity'] = 0;
                total['wind-speed'] = 0;
                var count = [];
                count['ambient-temperature'] = 0;
                count['ambient-humidity'] = 0;
                count['wind-speed'] = 0;

                var items = Object.values(r);
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var item = _step.value;

                        if (item['ambient-temperature']) {
                            total['ambient-temperature'] = total['ambient-temperature'] + item['ambient-temperature'];
                            count['ambient-temperature']++;
                        }
                        if (item['ambient-humidity']) {
                            total['ambient-humidity'] = total['ambient-humidity'] + item['ambient-humidity'];
                            count['ambient-humidity']++;
                        }
                        if (item['wind-speed']) {
                            total['wind-speed'] = total['wind-speed'] + item['wind-speed'];
                            count['wind-speed']++;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                $ctrl.latestWeather = [];
                $ctrl.latestWeather = {
                    'ambient-temperature': total['ambient-temperature'] / count['ambient-temperature'],
                    'ambient-humidity': total['ambient-humidity'] / count['ambient-humidity'],
                    'wind-speed': total['wind-speed'] / count['wind-speed']
                };
            }).catch(function (error) {
                console.error('Oops! Something went wrong', error);
            });

            var from = moment().startOf('hour').subtract(24, 'hours'),
                to = moment().endOf('hour');
            var promises = _.map($ctrl.panels, function (panel) {
                return measurementsService.getAggregated(panel, $ctrl.weatherFois, from, to, $ctrl.granularity);
            });

            $q.all(promises).then(function (r) {
                r.forEach(function (o) {
                    $ctrl.weatherCharts[o.modality.slug] = [{
                        key: [$ctrl.weatherFoi[$ctrl.translations['foi.name']], o.modality[$ctrl.translations['modality.name']]],
                        color: '#444',
                        values: o.measurements || [],
                        min: _.minBy(o.measurements, 'avg'),
                        max: _.maxBy(o.measurements, 'avg')
                    }];
                });
                $ctrl.onChartChange();
            }).catch(function (error) {
                console.error('Oops! Something went wrong', error);
            });
        };

        /**
         * 
         */
        $ctrl.onWeatherFoiChange = function () {

            if ($ctrl.weatherFoi.id == 'avg') {
                $ctrl.onWeatherAvg();
            } else {
                measurementsService.getLatestFoiMeasurements([$ctrl.weatherFoi]).then(function (r) {
                    $ctrl.latestWeather = r[$ctrl.weatherFoi.id];
                }).catch(function (error) {
                    console.error('Oops! Something went wrong', error);
                });

                var from = moment().startOf('hour').subtract(24, 'hours'),
                    to = moment().endOf('hour');
                var promises = _.map($ctrl.panels, function (panel) {
                    return measurementsService.getAggregated(panel, [$ctrl.weatherFoi], from, to, $ctrl.granularity);
                });

                $q.all(promises).then(function (r) {
                    r.forEach(function (o) {
                        $ctrl.weatherCharts[o.modality.slug] = [{
                            key: [$ctrl.weatherFoi[$ctrl.translations['foi.name']], o.modality[$ctrl.translations['modality.name']]],
                            color: $ctrl.lineColor ? $ctrl.lineColor : '#fff',
                            values: o.measurements || [],
                            min: _.minBy(o.measurements, 'avg'),
                            max: _.maxBy(o.measurements, 'avg')
                        }];
                    });
                    $ctrl.onChartChange();
                }).catch(function (error) {
                    console.error('Oops! Something went wrong', error);
                });
            }
        };

        $ctrl.onGasFoiChange = function () {

            measurementsService.getLatestFoiMeasurements([$ctrl.gasFoi]).then(function (r) {
                $ctrl.latestGasses = r[$ctrl.gasFoi.id];
            }).catch(function (error) {
                console.error('Oops! Something went wrong', error);
            });

            var from = moment().startOf('hour').subtract(24, 'hours'),
                to = moment().endOf('hour');
            var promises = _.map($ctrl.gasses, function (gas) {
                return measurementsService.getAggregated(gas, [$ctrl.gasFoi], from, to, $ctrl.granularity);
            });

            $q.all(promises).then(function (r) {
                r.forEach(function (o) {
                    $ctrl.gassesCharts[o.modality.slug] = o.measurements || [];
                });
            }).catch(function (error) {
                console.error('Oops! Something went wrong', error);
            });
        };

        /**
         * 
         */
        function getTranslations() {
            return $translate(['foi.name', 'iot.Wind', 'modality.name', 'compass.N', 'compass.NNE', 'compass.NE', 'compass.ENE', 'compass.E', 'compass.ESE', 'compass.SE', 'compass.SSE', 'compass.S', 'compass.SSW', 'compass.SW', 'compass.WSW', 'compass.W', 'compass.WNW', 'compass.NW', 'compass.NNW']);
        }

        function setTranslations(i18n) {

            $ctrl.panels['wind-speed'].name = i18n['iot.Wind'];
            $ctrl.panels['wind-speed'].name_el = i18n['iot.Wind'];

            $ctrl.compass = [i18n['compass.N'], i18n['compass.NNE'], i18n['compass.NE'], i18n['compass.ENE'], i18n['compass.E'], i18n['compass.ESE'], i18n['compass.SE'], i18n['compass.SSE'], i18n['compass.S'], i18n['compass.SSW'], i18n['compass.SW'], i18n['compass.WSW'], i18n['compass.W'], i18n['compass.WNW'], i18n['compass.NW'], i18n['compass.NNW']];
        }

        $ctrl.$onChanges = function (changesObj) {};
        $ctrl.$onDestroy = function () {};

        /**
         * 
         */
        function getUiConfig() {
            return {
                lineChart: {
                    config: {
                        deepWatchOptions: true,
                        deepWatchData: true,
                        deepWatchDataDepth: 1,
                        debounce: 100
                    },
                    options: {
                        title: { enable: false },
                        subtitle: { enable: false },

                        chart: {
                            type: 'lineWithFocusChart',

                            useInteractiveGuideline: true,

                            height: 170,
                            duration: 300,
                            showLegend: false,
                            focusEnable: true,

                            margin: { top: 20, right: 20, bottom: 20, left: 20 },

                            focus: {
                                height: 0
                            },

                            interpolate: 'cardinal',

                            defined: function defined(d, i) {
                                return d.avg !== null;
                            },

                            x: function x(d) {
                                return d.at;
                            },
                            y: function y(d) {
                                return d.avg;
                            },

                            xScale: d3.time.scale(),

                            xAxis: {
                                tickFormat: d3.currentLocale.timeFormat.multi([['%H:%M', function (d) {
                                    return d.getHours();
                                }], ['%a %d', function (d) {
                                    return d.getDay() && d.getDate() != 1;
                                }], ['%a %d', function (d) {
                                    return d.getDate() != 1;
                                }], ['%a %d', function (d) {
                                    return d.getMonth();
                                }], ['%a %d', function (d) {
                                    return true;
                                }]])
                            },
                            yAxis: { tickFormat: d3.format(',.0f') },

                            interactiveLayer: {
                                tooltip: {
                                    headerFormatter: d3.currentLocale.timeFormat.multi([['%d/%m/%Y %H:%M', function (d) {
                                        return true;
                                    }]]),
                                    keyFormatter: function keyFormatter(d, i) {
                                        return d[1];
                                    },
                                    valueFormatter: function valueFormatter(d, i, entry) {
                                        var output = '-';

                                        if (!isNaN(d)) {
                                            output = d3.format(',.2f')(d) + ' ' + $ctrl.activePanel.unit;

                                            if ($ctrl.activePanel.slug === 'wind-speed') {
                                                output += '<span>' + measurementsService.toBeaufort(d, true) + ' Bf</span> <span>' + measurementsService.toCompass(entry.data.dir, $ctrl.compass, '') + '</span>';
                                            }
                                        }

                                        return output;
                                    }
                                }
                            }
                        }
                    }
                },
                sparkLineChart: {
                    config: {
                        deepWatchOptions: true,
                        deepWatchData: true,
                        deepWatchDataDepth: 1,
                        debounce: 1000,
                        refreshDataOnly: true,
                        extended: true
                    },
                    options: {
                        title: { enable: false },
                        subtitle: { enable: false },

                        chart: {
                            type: 'sparklinePlus',
                            height: 26,
                            width: 120,
                            duration: 250,

                            margin: { top: 0, right: 0, bottom: 0, left: 0 },

                            x: function x(d) {
                                return d.at;
                            },
                            y: function y(d) {
                                return d.avg || 0;
                            },

                            xScale: d3.time.scale(),

                            xTickFormat: d3.time.format('%x'),

                            showMinMaxPoints: false,
                            showCurrentPoint: false,
                            showLastValue: false,
                            alignValue: false
                        }
                    }
                }

            };
        }
    }
})();